<template>
  <div class="im-card-message" :class="{ right: isMe }" @click="onTap">
    <div class="content-list">
      <div class="content-item">
        <div class="subtitle-head">
          <div class="subtitle-h3">
            <span class="h3">诊疗</span>
          </div>
        </div>
        <div class="content">
          <div class="txt">
            <span class="text">
              {{ messageContext.text }}
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { surgeryCb } from '../../utils/timInit'
export default {
  name: 'imCustomInspect',
  props: {
    message: {
      type: Object,
      default() {
        return {
          payload: {}
        }
      }
    }
  },
  data() {
    return {}
  },
  computed: {
    isMe() {
      // 手术消息特殊处理
      // 手术消息特殊处理
      // 手术消息特殊处理
      return true
      // return this.message.flow === 'out'
    },
    messageContext() {
      const data = JSON.parse(this.message.payload.data)
      return data.content
    }
  },
  methods: {
    onTap() {
      typeof surgeryCb === 'function' && surgeryCb(this.messageContext)
    }
  }
}
</script>

<style lang="scss" scoped>
.im-card-message {
  border-radius: 0 0.597333rem 0.597333rem 0.597333rem;
  background: #ffffff;
  box-shadow: 0rem 0.128rem 0.426667rem 0rem #ebeff9;

  &.right {
    border-radius: 0.597333rem 0 0.597333rem 0.597333rem;
    .title-wrap {
      border-radius: 0.597333rem 0 0 0;
    }
  }

  .title-wrap {
    padding: 0.384rem 0.512rem;
    font-size: 0.64rem;
    line-height: 0.853333rem;
    color: #ffffff;
    background: #0089ff;
    border-radius: 0 0.597333rem 0 0;

    & > .text {
      display: block;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
    }
  }

  .content-list {
    padding: 0.256rem 0.512rem;

    .content-item {
      position: relative;

      .subtitle-head {
        border-bottom: 0.021333rem solid #ececec;
      }

      .subtitle {
        display: flex;
        align-items: center;
        padding-top: 0.256rem;
        padding-bottom: 0.256rem;
        padding-left: 0.213333rem;
        color: #222222;
        font-weight: 500;
        overflow: hidden;

        &::before {
          content: '';
          margin-right: 0.213333rem;
          display: block;
          width: 0.085333rem;
          height: 0.469333rem;
          border-radius: 0.053333rem;
          background: #0089ff;
        }

        & > .text {
          display: block;
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
        }
      }

      .subtitle-h3 {
        padding-top: 0.597333rem;
        padding-bottom: 0.512rem;
        display: flex;
        align-items: center;
        overflow: hidden;

        .h3 {
          margin-right: 0.32rem;
          display: block;
          flex: 1;
          font-size: 0.64rem;
          line-height: 0.64rem;
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
          text-align: left;
        }

        .intro {
          flex: 2;
          font-size: 0.597333rem;
          line-height: 0.64rem;
          color: #888888;
          font-weight: 400;
          font-family: PingFangSC-Regular, PingFang SC, Menksoft Budun;
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
          text-align: right;
        }
      }

      .content {
        padding-top: 0.256rem;
        font-size: 0.64rem;
        line-height: 0.938667rem;
        color: #222222;

        .txt {
          padding-top: 0.256rem;
          padding-left: 0.298667rem;
          padding-bottom: 0.256rem;
          text-align: left;
          & > .text {
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 4;
            overflow: hidden;
            text-overflow: ellipsis;
            font-weight: 400;
            font-family: PingFangSC-Regular, PingFang SC, Menksoft Budun;
          }
        }
      }
    }
  }
}
</style>
